<button [type]="type" [class]="style + ' ' + size + ' ' + color + ' ' + border" [class.hidden]="hidden" [disabled]="disabled || loading" (click)="handleClick()">
  <span *ngIf="loading" class="spinner"></span>
  <i *ngIf="leftIcon" class="fas" [ngClass]="leftIcon"></i>
  {{text}}
</button>